export default "__VITE_ASSET__BfUjydyv__"